import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'finanzas',
        title    : 'Finanzas',
        translate: 'NAV.FINANCE',
        type     : 'group',
        children : [
            {
                id       : 'index',
                title    : 'Inicio',
                translate: 'NAV.ACCOUNTS.TITLE',
                type     : 'item',
                icon     : 'home',
                url      : '/dashboard'
            },
            {
                id       : 'cuentas',
                title    : 'Cuentas',
                translate: 'NAV.ACCOUNTS.TITLE',
                type     : 'item',
                icon     : 'account_balance_wallet',
                url      : '/gastos/finanzas/cuentas'
            },
            {
                id       : 'categoria-gastos',
                title    : 'Categorías de Gastos',
                translate: 'NAV.CATEGORY-EXPENSES',
                type     : 'item',
                icon     : 'category',
                url      : '/gastos/categorias/categorias-gastos'
            },
            {
                id       : 'suggests',
                title    : 'Sugerencias',
                translate: 'NAV.ACCOUNTS.TITLE',
                type     : 'item',
                icon     : 'feedback',
                url      : '/suggests'
            },
            //
        ]
    },
    {
        id       : 'prestamos',
        title    : 'Prestamos',
        translate: 'NAV.LOAN',
        type     : 'group',
        children : [
            {
                id       : 'lista',
                title    : 'Lista de Prestamos',
                translate: 'NAV.LOANLIST',
                type     : 'item',
                icon     : 'account_balance_wallet',
                url      : '/prestamos'
            }
        ]
    },
    {
        id       : 'comparte',
        title    : 'Compartir',
        translate: 'NAV.SHARED',
        type     : 'group',
        children : [
            {
                id       : 'index',
                title    : 'Comparte en tus redes',
                translate: 'NAV.ACCOUNTS.TITLE',
                type     : 'item',
                icon     : 'home',
                url      : '/shared'
            }
        ]
    }
];
